import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId/settings')({
  component: () => <Outlet />,
});
